import angular from 'angular';

export default angular
  .module('csm.ui.checkboxGroup', [])
  .directive('checkboxGroup', checkboxGroupDirective)
  .name; 

checkboxGroupDirective.$inject = [];

/*******************************************************************************
 * Directive: checkboxGroup */
/**
 * This restricts a group of checkboxes to have no more than one selected. To use
 * this directive, all checkboxes in the group must have the attribute
 * checkbox-group with the same name value.
 *
 *******************************************************************************/
/* @ngInject */
function checkboxGroupDirective() {
  /*****************************************************************************
   * Class: CSM_BoxGroup
   *
   * Manages a collection of checkboxes to ensure only one is selected.
   *****************************************************************************/
  function CSM_BoxGroup(name) {
    /** Group Name. */
    this.name = name;

    /** Checkbox List. */
    var mBoxes = [];

    /** Change in progress. */
    var mChangeInProg = false;

    /***************************************************************************
     * addBox */
    /**
     * Adds the box to the group and sets up event listeners.
     *
     * @param cb Checkbox element to add
     ***************************************************************************/
    this.addBox = function (cb) {
      if (!containsBox(cb)) {
        mBoxes.push(cb);
        cb.on('change', handleChange);
      }
    };

    /***************************************************************************
     * containsBox */
    /**
     * Returns an indication that the provided checkbox is part of this group.
     *
     * @param  cb  Checkbox element to check
     * @return     Boolean indication that the box is part of this group.
     ***************************************************************************/
    function containsBox(cb) {
      return mBoxes.indexOf(cb) > -1;
    }

    /***************************************************************************
     * handleChange */
    /**
     * Handle the change event of a checkbox. Clear the other selections when
     * a box is selected. Simulating the click will update any model values.
     *
     * @param  evt    Change event
     ***************************************************************************/
    var handleChange = function (event) {
      if (mChangeInProg) return;
      mChangeInProg = true;

      var target = event.target;
      if (target.checked) {
        mBoxes.forEach(function (cb) {
          var htmlElement = cb[0];
          if (htmlElement == target) return;

          if (htmlElement.checked) htmlElement.click();
        });
      }

      mChangeInProg = false;
    };

    /***************************************************************************
     * isEmpty */
    /**
     * Returns an indication if the group has any boxes.
     *
     * @return Boolean indication that the group has no boxes
     ***************************************************************************/
    this.isEmpty = function () {
      return mBoxes.length == 0;
    };

    /***************************************************************************
     * removeBox */
    /**
     * Removes the box from the group.
     *
     * @param cb Checkbox element to remove
     ***************************************************************************/
    this.removeBox = function (cb) {
      if (containsBox(cb)) {
        cb.off('change', handleChange);
        mBoxes.splice(mBoxes.indexOf(cb), 1);
      }
    };
  }

  /** Group Lookup Object. */ 
  var mGroups = {};

  /*****************************************************************************
   * addToGroup */
  /**
   * Adds the checkbox element to the group with the given name. If the group
   * doesn't exist, it will be created.
   *
   * @param cb     Checkbox element to add
   * @param group  Group name to add to.
   *****************************************************************************/
  function addToGroup(cb, group) {
    if (!mGroups.hasOwnProperty(group))
      mGroups[group] = new CSM_BoxGroup(group);

    mGroups[group].addBox(cb);
  }

  /*****************************************************************************
   * removeFromGroup */
  /**
   * Removes the checkbox element from the group with the given name. If the group
   * has no boxes in it after the removed, it will be dropped.
   *
   * @param cb     Checkbox element to remove
   * @param group  Group name to remove from
   *****************************************************************************/
  function removeFromGroup(cb, group) {
    if (!mGroups.hasOwnProperty(group)) return;

    mGroups[group].removeBox(cb);

    if (mGroups[group].isEmpty()) delete mGroups[group];
  }

  return {
    restrict: 'A',
    link: function (scope, element, attr) {
      if (!attr.checkboxGroup) throw new Error('Group name missing');

      addToGroup(element, attr.checkboxGroup);

      scope.$on('$destroy', function () {
        removeFromGroup(element, attr.checkboxGroup);
      });
    }
  };
}
